import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "Common/hooks/assets/theme";
import Login from "Common/Auth/SignIn";
import Register from "Common/Auth/SignUp";
import SelfShell from "../../Shell/SelfShell";
import SelfLandingPage from "../../Dashboards/SelfLearnerDashboard/SelfLandingPage";
import AvailableCourses from "../../Components/Courses/AvailableCourses";
import CourseDetail from "../../Components/Courses/CourseDetails";
import EnrolledCourses from "PlatForms/SelfLMS/Components/Courses/EnrolledCourses";
import EnrolledCourseDetails from "PlatForms/SelfLMS/Components/Courses/EnrolledCourseDetails";
import PageDetails from "PlatForms/SelfLMS/Components/Courses/PageDetails";
import AssessmentPage from "PlatForms/SelfLMS/Components/Courses/Assessment";
import CredentialsPage from "PlatForms/SelfLMS/Components/Credentials/Credentails";
import CertificateDetailPage from "PlatForms/SelfLMS/Components/Credentials/CertificateDetails";
import SelfLearnerProfile from "PlatForms/SelfLMS/Components/Profile/SelfLearnerProfile";
import PersonalInterest from "PlatForms/SelfLMS/Components/PersonalInterest/PersonalInterest";
import PaymentSuccess from "PlatForms/SelfLMS/Components/Payment/PaymentSuccess";
import PaymentCancel from "PlatForms/SelfLMS/Components/Payment/PaymentCancle";
import PaymentLedgerPage from "PlatForms/SelfLMS/Components/PaymentLedger/PaymentLedger";
import PaymentLedgerDetailPage from "PlatForms/SelfLMS/Components/PaymentLedger/PaymentLedgerDetail";
import ExpertServiceDetailPage from "PlatForms/SelfLMS/Components/ExpertService/ExpertServiceDetail";
import PurchasedExpertServicesPage from "PlatForms/SelfLMS/Components/ExpertService/PurchasedExpertServices";

function SelfLearnerContent() {
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem("currentPath", location.pathname);
  }, [location.pathname]);

  // Certificate detail is a full-bleed, shareable/printable page: render it
  // without the dashboard shell.
  const isCertificatePage = location.pathname.includes("/certificate/");

  const routesEl = (
    <Routes>
      {/* Dashboard */}
      <Route path="/" element={<SelfLandingPage />} />

      {/* Courses */}
      <Route path="/available-courses" element={<AvailableCourses />} />
      <Route path="/enrolled-courses" element={<EnrolledCourses />} />

      {/* Payment ledger */}
      <Route path="/payment-ledger" element={<PaymentLedgerPage />} />
      <Route path="/payment-ledger-detail/:ledgerId" element={<PaymentLedgerDetailPage />} />

      {/* Credentials */}
      <Route path="/credentials" element={<CredentialsPage />} />
      <Route path="certificate/:certificateId" element={<CertificateDetailPage />} />

      {/* Course detail / player */}
      <Route path="/available-courses/courses/:courseId" element={<CourseDetail />} />
      <Route path="/enrolled-courses/courses/:enrollmentId" element={<EnrolledCourseDetails />} />
      <Route
        path="/enrolled-courses/:enrollmentId/modules/:moduleProgressId/pages/:pageId"
        element={<PageDetails />}
      />
      <Route
        path="/enrolled-courses/:enrollmentId/modules/:moduleProgressId/assessment"
        element={<AssessmentPage />}
      />

      {/* Profile / interests */}
      <Route path="/selfLearner-profile" element={<SelfLearnerProfile />} />
      <Route path="/personal-interest" element={<PersonalInterest />} />

      {/* Course payment callbacks */}
      <Route path="/courseenroll/payment-success" element={<PaymentSuccess />} />
      <Route path="/courseenroll/payment-cancel" element={<PaymentCancel />} />

      {/* Expert services (access is only via paid course enrollment with the Expert Service add-on) */}
      <Route path="/purchased-expert-services" element={<PurchasedExpertServicesPage />} />
      <Route path="/learner/expert-services/:serviceId" element={<ExpertServiceDetailPage />} />

      {/* Auth */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isCertificatePage ? routesEl : <SelfShell>{routesEl}</SelfShell>}
    </ThemeProvider>
  );
}

export default SelfLearnerContent;
